import React, { Component } from 'react';
import PropTypes from "prop-types";

import './FixedNotification.css';

class FixedNotification extends Component {
  static propTypes = {
    onFadeComplete: PropTypes.func.isRequired,
    displayTime: PropTypes.number.isRequired,
    afterDisplayTime: PropTypes.number.isRequired,
    children: PropTypes.shape.isRequired,
    fullscreen: PropTypes.bool,
  };

  static defaultProps = {
    fullscreen: null,
  };

  static defaultProps = {
    onFadeComplete: null,
    displayTime: 1000,
    afterDisplayTime: 1000,
  };

  state = {
    fadeout: false,
  };

  onFadeComplete = () => {
    if (this.props.onFadeComplete) {
      this.setState({ fadeout: true });
      setTimeout(
        () => {
          this.props.onFadeComplete();
        }, this.props.afterDisplayTime);
    }
  }

  _calculateClassName = () => {
    let className = 'fixed-notification__component';
    if (this.props.fullscreen) { className += ' fullscreen'; }
    if (this.state.fadeout) { className += ' fadeout'; }
    return className;
  };

  render() {
    if (this.props.onFadeComplete) {
      setTimeout(() => { this.onFadeComplete(); }, this.props.displayTime);
    }

    return (
      <div className={this._calculateClassName()}>
        <div className="content-wrapper">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default FixedNotification;
